import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAlien: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="alien"><path d="M20 11C20 17 14 22 12 22C10 22 4 17 4 11C4 6.58172 7.58172 3 12 3C16.4183 3 20 6.58172 20 11Z" stroke="currentColor" strokeWidth="2" strokeLinecap="square"/><path d="M7.5 11.0086C8.96473 10.9201 9.88847 11.5134 10 12.9944C8.56755 13.0583 7.55498 12.5838 7.5 11.0086Z" stroke="currentColor" strokeWidth="2" strokeLinecap="square"/><path d="M16.5 11.0086C15.0353 10.9201 14.1115 11.5134 14 12.9944C15.4325 13.0583 16.445 12.5838 16.5 11.0086Z" stroke="currentColor" strokeWidth="2" strokeLinecap="square"/></CentralIconBase>;
};

export default IconAlien;
